export enum RefundType {
  SAME_METHOD = "SAME_METHOD",
  STORE_CREDIT = "STORE_CREDIT",
}
